import React, { Component } from "react";

export default class MainHeader extends Component {
  render() {
    return (
      <div className="main-header">
        <h2 className="main-header__top">Ferofly</h2>
        <h2 className="main-header__bottom">---Magnify your Journey---</h2>
      </div>
    );
  }
}
